import { isEmpty } from "lodash"
import React from 'react'
import { useMobileRecordsContext } from '../../contexts/mobileRecordsContext'
import { PhotoProvider } from "../../contexts/photoContext"
import { useProjectContext } from "../../contexts/projectContext"
import LightBox from "../photoGallery/photo/lightBox"
import LoadingSpinner from '../shared/loadingSpinner'
import Onboarding from '../shared/onboarding'
import MobileRecordHeader from "./header"
import Layout from "./layout"
import RenderRow from "./renderRow"
import TabRecords from "./tabRecords"

const MobileRecords = ({ children }) => {
  const { mobileRecords, loading } = useMobileRecordsContext()
  const { project, portfolio, routes, showMap } = useProjectContext()

  return (
    <PhotoProvider>
      <div className='flex flex-col flex-1 h-full'>
        <MobileRecordHeader />
        {loading && <LoadingSpinner />}
        {!loading && !isEmpty(mobileRecords) && (
          <Layout project={project} portfolio={portfolio} routes={routes} showMap={showMap}>
            <RenderRow />
            <TabRecords />
            {children}
          </Layout>
        )}
        {!loading && isEmpty(mobileRecords) && (
          <div className='flex flex-col lg:flex-row lg:gap-x-2 flex-grow overflow-hidden'>
            <div className='flex flex-col w-full h-2/3 lg:h-auto lg:w-1/2 flex-grow overflow-scroll'>
              <Onboarding title='No notes found.' />
            </div>
          </div>
        )}
      </div>
      <LightBox />
    </PhotoProvider>
  )
}

export default MobileRecords
